import React from 'react';

import autoBind from 'react-autobind';
import Switch, { Case } from 'react-switch-case';

// import other components within the same project here

import Localization from "composer/Localization.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Tabs, Tab, Button, IconButton, Tooltip, TextField, Icon, FormControl, Select, MenuItem, Grid } from '@material-ui/core';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';

class AdminTaskDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      activeTab: 0,
      searchText: "",
      totalPage: 0,
      currentPage: 0,
      schoolList: [],
      newUser: {
        username: "",
        displayName: "",
        email: "",
        password0: "",
        password1: "",
        accessRight: 0,
        schoolID: "",
      },
      tableRows: [],
    };
    autoBind(this);
    this.props.root.refs.API.request("get_school_list", {}, this.getSchoolListOK, this.getSchoolListFailed);

  }

  getTasks() {
    return [Localization.strings.CREATE_USER, Localization.strings.USER_LIST, Localization.strings.CREATE_SCHOOL, Localization.strings.SCHOOL_LIST];
  }

  getSchoolListOK(res) {
    let tmpList = [];
    let schoolList = res.body['result'];
    for (let i = 0; i < schoolList.length; i++) {
      let schoolRow = schoolList[i];
      tmpList.push({
        school_id: schoolRow['id'],
        shcool_name: schoolRow['name'],
        school_eng_name: schoolRow['name_eng'],
        school_locale: schoolRow['locale'],
        school_key: schoolRow['key'],
        school_type: schoolRow['school_type']
      });
    }
    this.setState({
      schoolList: tmpList,
    });
    this.state.schoolList = tmpList;
  }

  getSchoolListFailed(err) {
    console.log("get school list failed");
  }

  changeTab(index) {
    let newIndex = this.state.activeTab;
    if (newIndex == index) {
      return;
    }
    newIndex = index;
    this.setState({
      activeTab: newIndex,
      searchText: "",
      tableRows: [],
    });
    this.state.activeTab = newIndex;
    this.state.searchText = "";
    this.state.tableRows = [];
  }

  handleTabChange = (event, index) => {
    this.changeTab(index);
  }

  close() {
    this.setState({ open: false });
    this.state.open = false;
  }

  handleClose() {
    this.setState({ activeTab: 0 });
    this.state.activeTab = 0;
    this.close();
  }

  handleChange = name => event => {
    let user = this.state.newUser;
    user[name] = event.target.value;
    this.setState({ newUser: user });
    this.state.newUser = user;
  }

  createUserClicked() {
    let user = this.state.newUser;
    if (
      user.username != "" &&
      user.password0 != "" &&
      user.password0 == user.password1 &&
      user.schoolID != ""
    ) {
      let requestObj = {
        username: user.username,
        display_name: user.displayName,
        email: user.email,
        role: user.accessRight,
        school_id: user.schoolID,
        new_password: user.password0,
      }
      this.props.root.refs.API.request("user_admin_create_user", requestObj, this.createUserOK, this.createUserFailed);
    }
  }

  createUserOK(res) {
    console.log("create user ok");
    this.props.root.addNotification(Localization.strings.CREATED, true);
  }

  createUserFailed(err) {
    console.log("create user failed " + err);
  }

  createUser() {
    return (
      <div>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={8} sm={2}>
            用戶名稱
          </Grid>
          <Grid item xs={8} sm={10}>
            <TextField value={this.state.newUser.username} onChange={this.handleChange('username')}
              margin="normal"
              size="small"
              variant="outlined"
            />

          </Grid>
          <Grid item xs={8} sm={2}>
            顯示名稱(optional)
          </Grid>
          <Grid item xs={8} sm={10}>
            <TextField value={this.state.newUser.displayName} onChange={this.handleChange('displayName')}
              margin="normal"
              size="small"
              variant="outlined" />
          </Grid>
          <Grid item xs={8} sm={2}>
            Email
            (optional)
          </Grid>
          <Grid item xs={8} sm={10}>
            <TextField value={this.state.newUser.email} onChange={this.handleChange('email')}
              margin="normal"
              size="small"
              variant="outlined" />
          </Grid>
          <Grid item xs={8} sm={2}>
            密碼
          </Grid>
          <Grid item xs={8} sm={10}>
            <TextField value={this.state.newUser.password0} onChange={this.handleChange('password0')} type="password"
              margin="normal"
              size="small"
              variant="outlined"
            />
          </Grid>
          <Grid item xs={8} sm={2}>
            再輸入密碼
          </Grid>
          <Grid item xs={8} sm={10}>
            <TextField value={this.state.newUser.password1} onChange={this.handleChange('password1')} type="password"
              margin="normal"
              size="small"
              variant="outlined" />
          </Grid>
          <Grid item xs={8} sm={2}>
            權限
          </Grid>
          <Grid item xs={8} sm={10}>
            <FormControl>
              <Select
                value={this.state.newUser.accessRight}
                onChange={this.handleChange('accessRight')}
              >
                <MenuItem value={0}>一般用戶</MenuItem>
                <MenuItem value={1}>進階用戶</MenuItem>
                <MenuItem value={2}>管理員</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={8} sm={2}>
            學校編號
          </Grid>
          <Grid item xs={8} sm={10}>
            <TextField value={this.state.newUser.schoolID} onChange={this.handleChange('schoolID')}
              margin="normal"
              size="small"
              variant="outlined" />
          </Grid>
          <Grid item xs={8} sm={2}>
          </Grid>
          <Grid item xs={8} sm={10}>
            <Button
              color="primary"
              variant="contained"
              onClick={this.createUserClicked}
            >
              {Localization.strings.CREATE}
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }

  userList() {
    return [
      this.pageNavigator(),
      <TextField key="searchText"
        value={this.state.searchText}
        onChange={this.searchTextChanged}
        placeholder={Localization.strings.SEARCH + "..."}
        onKeyPress={this.handleSearchEnterPressed}
        margin="dense"
        size="small"
        variant="outlined"
      />,
      <Tooltip key="searchTooltip" title={Localization.strings.SEARCH}>
        <IconButton
          onClick={this.handleSearchClicked}
        >
          <Icon>search</Icon>
        </IconButton>
      </Tooltip >,
      <Table key="userTable" stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell>編號</TableCell>
            <TableCell>帳號名稱</TableCell>
            <TableCell>顯示名稱</TableCell>
            <TableCell>電郵</TableCell>
            <TableCell>權限</TableCell>
            <TableCell>學校名稱</TableCell>
            <TableCell>最近登入</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            this.state.tableRows.map((row, i) => (
              <TableRow key={i} style={{
                height: 50
              }}>
                <TableCell colSpan={10} component="th" scope="row">
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    ];
  }

  schoolList() {
    return [
      this.pageNavigator(),
      <TextField key="searchText"
        value={this.state.searchText}
        onChange={this.searchTextChanged}
        placeholder={Localization.strings.SEARCH + "..."}
        onKeyPress={this.handleSearchEnterPressed}
        margin="dense"
        size="small"
        variant="outlined"
      />,
      <Tooltip key="searchTooltip" title={Localization.strings.SEARCH}>
        <IconButton
          onClick={this.handleSearchClicked}
        >
          <Icon>search</Icon>
        </IconButton>
      </Tooltip>,
      <Table key="schoolTable">
        <TableHead>
          <TableRow>
            <TableCell>編號</TableCell>
            <TableCell>學校名稱</TableCell>
            <TableCell>學校名稱(Eng)</TableCell>
            <TableCell>地區</TableCell>
            <TableCell>Key</TableCell>
            <TableCell>類別</TableCell>
          </TableRow>
        </TableHead>

        {this.state.schoolList.map((listValue, index) => {
          return (
            <tr key={index}>
              <td>{listValue.school_id}</td>
              <td>{listValue.shcool_name}</td>
              <td>{listValue.school_eng_name}</td>
              <td>{listValue.school_locale}</td>
              <td>{listValue.school_key}</td>
              <td>{listValue.school_type}</td>
            </tr>
          );
        })}

      </Table>
    ];
  }

  searchTextChanged(e) {
    this.setState({ searchText: e.target.value });
    this.state.searchText = e.target.value;
  }

  handleSearchClicked() {

  }

  handleSearchEnterPressed(e) {
    if (e.key === "Enter") {
      this.handleSearchClicked();
    }
  }

  previosPage() {
    let page = this.state.currentPage;
    page--;
    if (page < 0) {
      page = 0;
    }
    this.changePage(page);
  }

  nextPage() {
    let page = this.state.currentPage;
    page++;
    if (page > this.state.totalPage - 1) {
      page = this.state.totalPage - 1;
    }
    this.changePage(page);
  }

  pageChanged(e) {
    let page = e.target.value;
    this.setState({ currentPage: page });
    this.state.currentPage = page;
    this.refreshList();
  }

  refreshList() {

  }

  pageNavigator() {
    let pages = [];
    for (let i = 0; i < this.state.totalPage; i++) {
      pages.push(i);
    }
    return [
      <div key="page" style={{ padding: '0 12px 0 0', display: 'inline-block' }}>{Localization.strings.PAGE}</div>,
      <FormControl key="currentPage" margin='dense'>
        <Select
          value={this.state.currentPage}
          onChange={this.pageChanged}
        >
        </Select>
      </FormControl>,
      <IconButton
        onClick={this.previosPage}
        disabled={this.state.currentPage <= 0}
      >
        <Icon>keyboard_arrow_left</Icon>
      </IconButton>,
      <IconButton
        onClick={this.nextPage}
        disabled={this.state.currentPage + 1 >= this.state.totalPage}
      >
        <Icon>keyboard_arrow_right</Icon>
      </IconButton>
    ];
  }

  render() {
    let tasks = this.getTasks();
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'lg'}
          onClose={this.handleClose}
        >
          <DialogTitle>
            {Localization.strings.ADMIN_TASK}
          </DialogTitle>

          <DialogContent>
            <Tabs
              value={this.state.activeTab}
              onChange={this.handleTabChange}
              indicatorColor="primary"
              textColor="primary"
              centered
              variant="fullWidth"
              style={{ padding: '0 0 14px 0' }}
            >
              {tasks.map((label, index) => {
                return (
                  <Tab key={index} label={label} />
                );
              })}
            </Tabs>
            <Switch condition={this.state.activeTab}>
              <Case value={0}>
                {this.createUser()}
              </Case>
              <Case value={1}>
                {this.userList()}
              </Case>
              <Case value={3}>
                {this.schoolList()}
              </Case>
            </Switch>
          </DialogContent>

          <DialogActions style={{ padding: '16px 24px' }}>
            <Button
              color="primary"
              variant="contained"
              onClick={this.handleClose}
            >
              {Localization.strings.DONE}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default AdminTaskDialog;
